/**
 * Dr.Water Bundle System — Editorial direction
 * Web Components: <bundle-cross-sell>, <bundle-volume-tier>
 * Multi-line /cart/add.js; Shopify Automatic Discounts apply at cart.
 */
(function () {
  'use strict';

  var CART_ADD = '/cart/add.js';

  function fireEvent(name, payload) {
    var fullName = 'bundle_' + name;
    try {
      window.dataLayer = window.dataLayer || [];
      var d = { event: fullName };
      if (payload) for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) d[k] = payload[k];
      window.dataLayer.push(d);
    } catch (e) {}
    try {
      if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', fullName, payload || {}]);
      }
    } catch (e) {}
  }

  function getCartSectionIds() {
    var ids = [];
    document.querySelectorAll(
      'cart-items-component[data-section-id], cart-items-list-component[data-section-id], cart-icon-component[data-section-id], cart-drawer-component[data-section-id]'
    ).forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function postCartAdd(items) {
    var body = { items: items };
    var sectionIds = getCartSectionIds();
    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (err) {
          throw new Error(err.description || err.message || ('Cart add failed (' + res.status + ')'));
        });
      }
      return res.json();
    });
  }

  function notifyCart(detail) {
    var data = detail || {};
    var ev;
    try {
      ev = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data.resource,
          sourceId: data.source || 'bundle',
          data: {
            source: data.source || 'bundle',
            sections: data.sections,
            itemCount: data.itemCount
          }
        }
      });
      document.dispatchEvent(ev);
    } catch (e) {}
  }

  function revealCart() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      try { drawer.open(); return true; } catch (e) {}
    }
    if (drawer) {
      try { drawer.setAttribute('auto-open', ''); return true; } catch (e) {}
    }
    return false;
  }

  function flashAdded(button, ms) {
    if (!button) return;
    if (button._dwAtcResetTimer) clearTimeout(button._dwAtcResetTimer);
    button.dataset.added = 'true';
    button._dwAtcResetTimer = setTimeout(function () {
      button.removeAttribute('data-added');
      button._dwAtcResetTimer = null;
    }, ms || 1500);
  }
  function clearAddedFlash(button) {
    if (!button) return;
    if (button._dwAtcResetTimer) {
      clearTimeout(button._dwAtcResetTimer);
      button._dwAtcResetTimer = null;
    }
    button.removeAttribute('data-added');
  }

  function showStatus(el, state, msg) {
    if (!el) return;
    el.dataset.state = state;
    el.textContent = msg;
    el.hidden = false;
  }

  function hexFallback(colorName) {
    if (!colorName) return '';
    var map = {
      'cloud': '#EAEAEA', 'white': '#EAEAEA',
      'sky': '#9BD3E8', 'blue': '#9BD3E8',
      'peacock': '#142B77', 'navy': '#142B77',
      'onyx': '#222222', 'black': '#222222'
    };
    return map[String(colorName).toLowerCase()] || '';
  }

  /* ===== Pattern A — Cross-sell ===== */
  class BundleCrossSell extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.cta = this.querySelector('[data-bundle-cta]');
      this.statusEl = this.querySelector('.dw-bundle__status');
      this.addonThumb = this.querySelector('[data-addon-thumb]');
      this.addonColorName = this.querySelector('[data-addon-color-name]');
      this.anchorVariantId = parseInt(this.dataset.anchorVariantId, 10);
      this.currentAddonVariantId = parseInt(this.dataset.addonVariantId, 10);
      this.pdpTemplate = this.dataset.pdpTemplate || '';

      var self = this;
      this.querySelectorAll('[data-bundle-color-picker] input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function (e) { self.onColorPick(e); });
      });
      if (this.cta) this.cta.addEventListener('click', this.handleAdd.bind(this));

      fireEvent('viewed', {
        bundle_type: 'cross_sell',
        pdp_template: this.pdpTemplate,
        anchor_handle: this.dataset.anchorHandle,
        addon_handle: this.dataset.addonHandle
      });
    }

    onColorPick(e) {
      var input = e.target;
      if (input.disabled) return;
      var variantId = parseInt(input.dataset.variantId, 10);
      if (!variantId) return;
      this.currentAddonVariantId = variantId;

      this.querySelectorAll('[data-bundle-color-picker] .dw-swatch').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      var swatch = input.closest('.dw-swatch');
      if (swatch) swatch.classList.add('is-selected');

      if (this.addonThumb && input.dataset.variantImage) {
        this.addonThumb.src = input.dataset.variantImage;
      }
      if (this.addonColorName && input.dataset.variantName) {
        this.addonColorName.textContent = input.dataset.variantName;
      }

      fireEvent('variant_selected', {
        bundle_type: 'cross_sell',
        pdp_template: this.pdpTemplate,
        addon_variant_id: variantId,
        color_name: input.dataset.variantName
      });
    }

    handleAdd() {
      if (!this.cta || this.cta.disabled) return;
      if (!this.anchorVariantId || !this.currentAddonVariantId) {
        showStatus(this.statusEl, 'error', 'Bundle products are missing. Please contact support.');
        return;
      }
      var self = this;
      var originalText = this.cta.textContent;
      this.cta.disabled = true;
      this.cta.textContent = 'Adding…';
      if (this.statusEl) this.statusEl.hidden = true;

      var items = [
        { id: this.anchorVariantId, quantity: 1 },
        { id: this.currentAddonVariantId, quantity: 1 }
      ];

      postCartAdd(items).then(function (result) {
        fireEvent('added_to_cart', {
          bundle_type: 'cross_sell',
          pdp_template: self.pdpTemplate,
          anchor_variant_id: self.anchorVariantId,
          addon_variant_id: self.currentAddonVariantId
        });
        showStatus(self.statusEl, 'success', 'Bundle added to cart');
        notifyCart({ source: 'product-form-component', resource: result, sections: result && result.sections, itemCount: result && result.item_count });
        setTimeout(function () {
          if (!revealCart()) {
            window.location.href = '/cart';
          }
        }, 250);
      }).catch(function (err) {
        showStatus(self.statusEl, 'error', (err && err.message) || 'Could not add bundle. Please try again.');
        fireEvent('add_to_cart_error', { bundle_type: 'cross_sell', error: err && err.message });
      }).finally(function () {
        self.cta.disabled = false;
        self.cta.textContent = originalText;
      });
    }
  }

  /* ===== Pattern B — Volume tier ===== */
  class BundleVolumeTier extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.statusEl = this.querySelector('.dw-bundle__status');
      this.pdpTemplate = this.dataset.pdpTemplate || '';
      this.tierProductTitle = this.dataset.tierProductTitle || '';
      this.fallbackVariantId = parseInt(this.dataset.tierProductVariantId, 10);
      this.isSegmented = this.dataset.layout === 'segmented' || this.classList.contains('dw-bundle--segmented');
      this.skipEnabled = this.dataset.skipLink === 'true';

      try {
        this.colors = JSON.parse(this.dataset.tierColors || '[]');
      } catch (e) { this.colors = []; }

      this.currentTier = parseInt(this.dataset.defaultTier, 10) || 1;
      this.slots = { 1: [], 2: [], 3: [] };

      this.initSlots();

      var self = this;
      if (this.isSegmented) {
        this.heroImg = this.querySelector('[data-hero-img]');
        this.heroSave = this.querySelector('[data-hero-save]');
        this.tierStrike = this.querySelector('[data-tier-strike]');
        this.tierEach = this.querySelector('[data-tier-each]');
        this.tierPriceEl = this.querySelector('[data-tier-price]');
        this.slotsPanel = this.querySelector('[data-tier-slots-segmented]');
        this.segments = this.querySelectorAll('.dw-bundle__segment');
        this.segments.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            self.selectSegmentedTier(parseInt(e.currentTarget.dataset.tier, 10));
          });
        });
        this.renderSegmentedSlots(this.currentTier);
      } else {
        this.renderSlotPanels();
        this.querySelectorAll('input[type="radio"][name^="dw-tier-"]').forEach(function (radio) {
          radio.addEventListener('change', function () { self.onTierChange(radio); });
        });
      }
      this.bindExternalAtc();
      this.applyAtcLabelFromCurrent();

      fireEvent('viewed', {
        bundle_type: 'volume_tier',
        pdp_template: this.pdpTemplate,
        product_handle: this.dataset.tierProductHandle,
        default_tier: this.currentTier,
        has_color_picker: this.colors.length > 1,
        layout: this.isSegmented ? 'segmented' : 'tiers'
      });
    }

    bindExternalAtc() {
      var self = this;
      if (!this.canHandleAdd()) return;
      var scope = this.closest('section, .shopify-section') || document;
      var form = scope.querySelector('product-form-component:not(.quick-add__product-form-component)');
      if (!form) return;
      this.productForm = form;
      this.atcButton = form.querySelector('[ref="addToCartButton"]');
      this.atcTextEl = this.atcButton ? this.atcButton.querySelector('.add-to-cart-text__content') : null;
      this.atcInnerText = this.atcTextEl ? this.atcTextEl.querySelector('span span') : null;
      if (this.atcButton) {
        this.atcButton.addEventListener('click', function (e) {
          if (!self.canHandleAdd()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleAdd();
        }, true);
      }
      var nativeForm = form.querySelector('form');
      if (nativeForm) {
        nativeForm.addEventListener('submit', function (e) {
          if (!self.canHandleAdd()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleAdd();
        }, true);
      }

      this.buyNowButton = form.querySelector('.buy-now-button[data-buy-now]');
      if (this.buyNowButton && this.skipEnabled && this.fallbackVariantId) {
        this.buyNowButton.classList.add('dw-bundle-skip-link');
        this.buyNowButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleSkip();
        }, true);
        if (this.tierProductTitle) {
          this.buyNowButton.textContent = 'Buy ' + this.tierProductTitle + ' now';
        }
      }
    }

    canHandleAdd() {
      return !!(this.fallbackVariantId || (this.colors && this.colors.length));
    }

    handleSkip() {
      if (!this.fallbackVariantId) return;
      if (!this.buyNowButton || this.buyNowButton.disabled) return;
      var self = this;
      var originalText = this.buyNowButton.textContent;
      var originalDisabled = this.buyNowButton.disabled;
      clearAddedFlash(this.buyNowButton);
      this.buyNowButton.disabled = true;
      this.buyNowButton.textContent = 'Adding…';
      if (this.statusEl) this.statusEl.hidden = true;

      revealCart();

      postCartAdd([{ id: this.fallbackVariantId, quantity: 1 }]).then(function (result) {
        fireEvent('added_to_cart', {
          bundle_type: 'volume_tier',
          kind: 'skip',
          pdp_template: self.pdpTemplate,
          variant_id: self.fallbackVariantId
        });
        showStatus(self.statusEl, 'success', 'Added to cart');
        notifyCart({ source: 'product-form-component', resource: result, sections: result && result.sections, itemCount: result && result.item_count });
        flashAdded(self.buyNowButton, 1500);
        if (!revealCart()) window.location.href = '/cart';
      }).catch(function (err) {
        showStatus(self.statusEl, 'error', (err && err.message) || 'Could not add to cart.');
        fireEvent('add_to_cart_error', { bundle_type: 'volume_tier', kind: 'skip', error: err && err.message });
      }).finally(function () {
        self.buyNowButton.disabled = originalDisabled;
        self.buyNowButton.textContent = originalText;
      });
    }

    setAtcText(label, priceSuffix) {
      var text = (label || '') + (priceSuffix ? ' · ' + priceSuffix : '');
      if (this.atcInnerText) {
        this.atcInnerText.textContent = text;
      } else if (this.atcTextEl) {
        this.atcTextEl.textContent = text;
      }
    }

    applyAtcLabelFromCurrent() {
      if (!this.canHandleAdd()) return;
      var qty = this.currentTier;
      var price = '';
      if (this.isSegmented) {
        var seg = this.querySelector('.dw-bundle__segment[data-tier="' + qty + '"]');
        if (seg) price = seg.dataset.price || '';
      } else {
        var radio = this.querySelector('input[type="radio"][name^="dw-tier-"]:checked');
        if (radio) price = radio.dataset.tierPrice || '';
      }
      this.setAtcText('Add ' + qty + ' to cart', price);
    }

    selectSegmentedTier(qty) {
      if (!qty || qty < 1) return;
      var from = this.currentTier;
      this.currentTier = qty;
      var btn = this.querySelector('.dw-bundle__segment[data-tier="' + qty + '"]');
      if (!btn) return;

      this.segments.forEach(function (s) {
        var sel = s === btn;
        s.classList.toggle('is-active', sel);
        s.setAttribute('aria-selected', sel ? 'true' : 'false');
      });

      if (this.heroImg && btn.dataset.image) {
        this.heroImg.src = btn.dataset.image;
        if (btn.dataset.image2x) {
          this.heroImg.srcset = btn.dataset.image + ' 1x, ' + btn.dataset.image2x + ' 2x';
        }
      }

      if (this.heroSave) {
        if (btn.dataset.save) {
          this.heroSave.textContent = btn.dataset.save;
          this.heroSave.hidden = false;
        } else {
          this.heroSave.hidden = true;
        }
      }

      if (this.tierStrike) {
        this.tierStrike.textContent = btn.dataset.strike || '';
        this.tierStrike.hidden = !btn.dataset.strike;
      }
      if (this.tierEach) this.tierEach.textContent = btn.dataset.each || '';
      if (this.tierPriceEl) this.tierPriceEl.textContent = btn.dataset.price || '';

      this.setAtcText('Add ' + qty + ' to cart', btn.dataset.price || '');

      this.renderSegmentedSlots(qty);

      fireEvent('tier_selected', {
        bundle_type: 'volume_tier',
        pdp_template: this.pdpTemplate,
        tier_from: from,
        tier_to: qty,
        tier_price_label: btn.dataset.price,
        layout: 'segmented'
      });
    }

    renderSegmentedSlots(qty) {
      if (!this.slotsPanel) return;
      if (!this.colors.length || this.colors.length < 2) {
        this.slotsPanel.innerHTML = '';
        this.slotsPanel.hidden = true;
        return;
      }
      this.slotsPanel.innerHTML = this.slotPanelHTML(qty);
      this.slotsPanel.hidden = false;
      var self = this;
      this.slotsPanel.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function (e) { self.onSlotChange(qty, e); });
      });
    }

    initSlots() {
      var defaultColor = null;
      for (var i = 0; i < this.colors.length; i++) {
        if (this.colors[i].available) { defaultColor = this.colors[i]; break; }
      }
      if (!defaultColor && this.colors.length) defaultColor = this.colors[0];
      var defaultVariantId = defaultColor ? defaultColor.variantId : this.fallbackVariantId;
      for (var q = 1; q <= 3; q++) {
        var arr = [];
        for (var s = 0; s < q; s++) arr.push(defaultVariantId);
        this.slots[q] = arr;
      }
    }

    renderSlotPanels() {
      var self = this;
      [1, 2, 3].forEach(function (qty) {
        var panel = self.querySelector('[data-tier-slots="' + qty + '"]');
        if (!panel) return;
        if (!self.colors.length || self.colors.length < 2) {
          panel.innerHTML = '';
          return;
        }
        panel.innerHTML = self.slotPanelHTML(qty);
        panel.querySelectorAll('input[type="radio"]').forEach(function (input) {
          input.addEventListener('change', function (e) { self.onSlotChange(qty, e); });
        });
      });
    }

    slotPanelHTML(qty) {
      var self = this;
      var rows = '';
      for (var i = 0; i < qty; i++) {
        var currentId = this.slots[qty][i];
        var current = this.colors.find(function (c) { return c.variantId === currentId; }) || this.colors[0];
        var swatches = this.colors.map(function (c, ci) {
          var hex = c.hex || hexFallback(c.name);
          var styleAttr = hex ? ' style="--swatch-hex:' + hex + ';"' : '';
          var nameLc = (c.name || '').toLowerCase().replace(/"/g, '');
          var isSel = c.variantId === currentId;
          return (
            '<label class="dw-swatch' + (isSel ? ' is-selected' : '') + (c.available ? '' : ' is-soldout') + '"' +
            ' data-color-name="' + nameLc + '"' +
            styleAttr +
            ' title="' + escapeAttr(c.name) + '">' +
              '<input type="radio" name="slot-' + qty + '-' + i + '"' +
              ' value="' + c.variantId + '"' +
              ' data-variant-id="' + c.variantId + '"' +
              ' data-variant-image="' + escapeAttr(c.image || '') + '"' +
              ' data-variant-name="' + escapeAttr(c.name) + '"' +
              (isSel ? ' checked' : '') +
              (c.available ? '' : ' disabled') + '>' +
              '<span class="dw-swatch__dot" aria-hidden="true"></span>' +
              '<span class="dw-visually-hidden">' + escapeAttr(c.name) + '</span>' +
            '</label>'
          );
        }).join('');

        rows +=
          '<div class="dw-tier-slot" data-slot="' + i + '">' +
            '<div class="dw-tier-slot__thumb">' +
              (current.image ? '<img src="' + escapeAttr(current.image) + '" alt="" loading="lazy">' : '') +
            '</div>' +
            (qty > 1 ? '<span class="dw-tier-slot__label">Bottle ' + (i + 1) + '</span>' : '') +
            '<span class="dw-tier-slot__color-name">' + escapeAttr(current.name) + '</span>' +
            '<fieldset class="dw-tier-slot__swatches">' +
              '<legend class="dw-visually-hidden">Bottle ' + (i + 1) + ' colour</legend>' +
              swatches +
            '</fieldset>' +
          '</div>';
      }
      var label = qty === 1 ? 'Pick your colour' : 'Pick your ' + qty + ' colours';
      return '<div class="dw-tier-slots__eyebrow">' + label + '</div>' + rows;
    }

    onSlotChange(qty, e) {
      var input = e.target;
      if (input.disabled) return;
      var slotEl = input.closest('[data-slot]');
      if (!slotEl) return;
      var slotIdx = parseInt(slotEl.dataset.slot, 10);
      var variantId = parseInt(input.value, 10);
      this.slots[qty][slotIdx] = variantId;

      var img = slotEl.querySelector('.dw-tier-slot__thumb img');
      if (img && input.dataset.variantImage) img.src = input.dataset.variantImage;
      else if (input.dataset.variantImage) {
        var thumbEl = slotEl.querySelector('.dw-tier-slot__thumb');
        if (thumbEl) thumbEl.innerHTML = '<img src="' + input.dataset.variantImage + '" alt="" loading="lazy">';
      }
      var nameEl = slotEl.querySelector('.dw-tier-slot__color-name');
      if (nameEl && input.dataset.variantName) nameEl.textContent = input.dataset.variantName;

      slotEl.querySelectorAll('.dw-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      var swatch = input.closest('.dw-swatch');
      if (swatch) swatch.classList.add('is-selected');

      fireEvent('slot_variant_selected', {
        bundle_type: 'volume_tier',
        pdp_template: this.pdpTemplate,
        tier: qty,
        slot_index: slotIdx,
        variant_id: variantId,
        color_name: input.dataset.variantName
      });
    }

    onTierChange(radio) {
      var from = this.currentTier;
      var to = parseInt(radio.value, 10);
      this.currentTier = to;

      this.querySelectorAll('[data-tier-slots]').forEach(function (panel) {
        panel.hidden = parseInt(panel.dataset.tierSlots, 10) !== to;
      });

      var price = radio.dataset.tierPrice || '';
      this.setAtcText('Add ' + to + ' to cart', price);

      fireEvent('tier_selected', {
        bundle_type: 'volume_tier',
        pdp_template: this.pdpTemplate,
        tier_from: from,
        tier_to: to,
        tier_price_label: price
      });
    }

    handleAdd() {
      if (this._addInFlight) return;
      if (this.atcButton && this.atcButton.disabled) return;
      var tier = this.currentTier;
      var ids = (this.slots[tier] && this.slots[tier].length) ? this.slots[tier].slice() : [];
      if (!ids.length) {
        if (!this.fallbackVariantId) {
          showStatus(this.statusEl, 'error', 'Tier product is missing. Please contact support.');
          return;
        }
        for (var i = 0; i < tier; i++) ids.push(this.fallbackVariantId);
      }

      var counts = {};
      ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) {
        return { id: parseInt(id, 10), quantity: counts[id] };
      });

      var self = this;
      self._addInFlight = true;
      clearAddedFlash(this.atcButton);
      var originalAtcHTML = this.atcTextEl ? this.atcTextEl.innerHTML : '';
      var originalDisabled = this.atcButton ? this.atcButton.disabled : false;
      if (this.atcButton) this.atcButton.disabled = true;
      this.setAtcText('Adding…', '');
      if (this.statusEl) this.statusEl.hidden = true;

      revealCart();

      postCartAdd(items).then(function (result) {
        fireEvent('added_to_cart', {
          bundle_type: 'volume_tier',
          pdp_template: self.pdpTemplate,
          tier: tier,
          line_count: items.length,
          variant_ids: ids
        });
        showStatus(self.statusEl, 'success', 'Added to cart');
        notifyCart({ source: 'product-form-component', resource: result, sections: result && result.sections, itemCount: result && result.item_count });
        flashAdded(self.atcButton, 1500);
      }).catch(function (err) {
        showStatus(self.statusEl, 'error', (err && err.message) || 'Could not add to cart.');
        fireEvent('add_to_cart_error', { bundle_type: 'volume_tier', tier: tier, error: err && err.message });
      }).finally(function () {
        self._addInFlight = false;
        if (self.atcButton) self.atcButton.disabled = originalDisabled;
        if (self.atcTextEl) {
          self.atcTextEl.innerHTML = originalAtcHTML;
          self.atcInnerText = self.atcTextEl.querySelector('span span');
          self.applyAtcLabelFromCurrent();
        }
      });
    }
  }

  function escapeAttr(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ===== Pattern C — Multi-offer ===== */
  class BundleMultiOffer extends HTMLElement {
    connectedCallback() {
      if (this._wired) return;
      this._wired = true;
      this.heroSavings = this.querySelector('[data-hero-savings]');
      this.statusEl = this.querySelector('.dw-bundle__status');
      this.anchorVariantId = parseInt(this.dataset.anchorVariantId, 10);
      this.anchorTitle = this.dataset.anchorTitle || '';
      this.pdpTemplate = this.dataset.pdpTemplate || '';
      this.skipEnabled = this.dataset.skipLink === 'true';
      this.currentOffer = 'a';

      this.panels = this.querySelectorAll('.dw-bundle__offer-panel');
      this.tabs = this.querySelectorAll('.dw-bundle__tab');

      this.addonByOffer = {};
      var self = this;
      this.panels.forEach(function (panel) {
        var checked = panel.querySelector('[data-bundle-color-picker] input[type="radio"]:checked');
        if (checked) self.addonByOffer[panel.dataset.offer] = parseInt(checked.value, 10);
      });

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          self.switchOffer(e.currentTarget.dataset.offer);
        });
      });

      this.querySelectorAll('[data-bundle-color-picker] input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function (e) { self.onColorPick(e); });
      });

      this.bindExternalButtons();
      this.applyExternalLabels();

      fireEvent('viewed', {
        bundle_type: 'multi_offer',
        pdp_template: this.pdpTemplate,
        anchor_handle: this.dataset.anchorHandle,
        offers: Array.from(this.panels).map(function (p) { return p.dataset.offer; })
      });
    }

    bindExternalButtons() {
      var self = this;
      if (!this.anchorVariantId) return;
      var form = this.findProductForm();
      if (!form) return;
      this.productForm = form;
      this.atcButton = form.querySelector('[ref="addToCartButton"]');
      this.atcTextEl = this.atcButton ? this.atcButton.querySelector('.add-to-cart-text__content') : null;
      this.atcInnerText = this.atcTextEl ? this.atcTextEl.querySelector('span span') : null;
      this.buyNowButton = form.querySelector('.buy-now-button[data-buy-now]');

      if (this.atcButton) {
        this.atcButton.addEventListener('click', function (e) {
          if (!self.canHandleAdd()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleAdd();
        }, true);
      }
      var nativeForm = form.querySelector('form');
      if (nativeForm) {
        nativeForm.addEventListener('submit', function (e) {
          if (!self.canHandleAdd()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleAdd();
        }, true);
      }
      if (this.buyNowButton && this.skipEnabled) {
        this.buyNowButton.classList.add('dw-bundle-skip-link');
        this.buyNowButton.addEventListener('click', function (e) {
          if (!self.canHandleSkip()) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          self.handleSkip();
        }, true);
      }
    }

    findProductForm() {
      var scope = this.closest('section, .shopify-section') || document;
      return scope.querySelector('product-form-component:not(.quick-add__product-form-component)');
    }

    canHandleAdd() {
      if (!this.anchorVariantId) return false;
      var panel = this.panelFor(this.currentOffer);
      if (!panel) return false;
      if (panel.dataset.offerType === 'cross_sell') {
        var addonId = this.addonByOffer[this.currentOffer];
        if (!addonId) {
          var checked = panel.querySelector('[data-bundle-color-picker] input[type="radio"]:checked');
          if (!checked) return false;
        }
      }
      return true;
    }

    canHandleSkip() {
      return !!(this.anchorVariantId && this.skipEnabled);
    }

    setAtcText(label, priceSuffix) {
      var text = (label || '') + (priceSuffix ? ' · ' + priceSuffix : '');
      if (this.atcInnerText) {
        this.atcInnerText.textContent = text;
      } else if (this.atcTextEl) {
        this.atcTextEl.textContent = text;
      }
    }

    applyExternalLabels() {
      if (!this.canHandleAdd()) return;
      var panel = this.panelFor(this.currentOffer);
      if (panel) this.setAtcText(panel.dataset.ctaLabel, panel.dataset.total);
      if (this.buyNowButton && this.skipEnabled && this.anchorTitle) {
        this.buyNowButton.textContent = 'Buy ' + this.anchorTitle + ' now';
      }
    }

    switchOffer(key) {
      if (!key || key === this.currentOffer) return;
      var from = this.currentOffer;
      this.currentOffer = key;
      this.panels.forEach(function (p) { p.hidden = p.dataset.offer !== key; });
      this.tabs.forEach(function (t) {
        var sel = t.dataset.offer === key;
        t.classList.toggle('is-active', sel);
        t.setAttribute('aria-selected', sel ? 'true' : 'false');
      });
      var panel = this.panelFor(key);
      if (panel) {
        if (this.heroSavings) this.heroSavings.textContent = panel.dataset.heroSavings || '';
        this.setAtcText(panel.dataset.ctaLabel, panel.dataset.total);
      }
      fireEvent('offer_switched', {
        bundle_type: 'multi_offer',
        pdp_template: this.pdpTemplate,
        offer_from: from,
        offer_to: key
      });
    }

    onColorPick(e) {
      var input = e.target;
      if (input.disabled) return;
      var panel = input.closest('.dw-bundle__offer-panel');
      if (!panel) return;
      var offerKey = panel.dataset.offer;
      var variantId = parseInt(input.dataset.variantId, 10);
      this.addonByOffer[offerKey] = variantId;

      var img = panel.querySelector('[data-addon-thumb]');
      var lbl = panel.querySelector('[data-addon-color-name]');
      if (img && input.dataset.variantImage) img.src = input.dataset.variantImage;
      if (lbl && input.dataset.variantName) lbl.textContent = input.dataset.variantName;

      panel.querySelectorAll('.dw-swatch').forEach(function (s) { s.classList.remove('is-selected'); });
      var swatch = input.closest('.dw-swatch');
      if (swatch) swatch.classList.add('is-selected');

      fireEvent('variant_selected', {
        bundle_type: 'multi_offer',
        pdp_template: this.pdpTemplate,
        offer: offerKey,
        addon_variant_id: variantId,
        color_name: input.dataset.variantName
      });
    }

    panelFor(key) {
      return this.querySelector('.dw-bundle__offer-panel[data-offer="' + key + '"]');
    }

    handleAdd() {
      if (this._addInFlight) return;
      if (this.atcButton && this.atcButton.disabled) return;
      var panel = this.panelFor(this.currentOffer);
      if (!panel) return;
      var type = panel.dataset.offerType;
      var items = [];

      if (type === 'cross_sell') {
        var addonId = this.addonByOffer[this.currentOffer];
        if (!addonId) {
          var firstInput = panel.querySelector('[data-bundle-color-picker] input[type="radio"]:checked');
          if (firstInput) addonId = parseInt(firstInput.value, 10);
        }
        if (!this.anchorVariantId || !addonId) {
          showStatus(this.statusEl, 'error', 'Bundle products are missing. Please contact support.');
          return;
        }
        items = [
          { id: this.anchorVariantId, quantity: 1 },
          { id: addonId, quantity: 1 }
        ];
      } else if (type === 'volume') {
        var qty = parseInt(panel.dataset.volumeQty, 10) || 1;
        if (!this.anchorVariantId) {
          showStatus(this.statusEl, 'error', 'Bundle product is missing. Please contact support.');
          return;
        }
        items = [{ id: this.anchorVariantId, quantity: qty }];
      } else {
        showStatus(this.statusEl, 'error', 'Unknown offer type.');
        return;
      }

      this.postItems(items, type);
    }

    handleSkip() {
      if (!this.anchorVariantId) return;
      this.postItems([{ id: this.anchorVariantId, quantity: 1 }], 'skip');
    }

    postItems(items, kind) {
      var self = this;
      self._addInFlight = true;
      var btn = kind === 'skip' ? this.buyNowButton : this.atcButton;
      clearAddedFlash(btn);
      var originalDisabled = btn ? btn.disabled : false;
      var originalAtcHTML = this.atcTextEl ? this.atcTextEl.innerHTML : '';
      var originalBuyNowText = this.buyNowButton ? this.buyNowButton.textContent : '';

      if (btn) btn.disabled = true;
      if (kind === 'skip') {
        if (this.buyNowButton) this.buyNowButton.textContent = 'Adding…';
      } else {
        this.setAtcText('Adding…', '');
      }
      if (this.statusEl) this.statusEl.hidden = true;

      if (kind !== 'skip') revealCart();

      postCartAdd(items).then(function (result) {
        fireEvent('added_to_cart', {
          bundle_type: 'multi_offer',
          pdp_template: self.pdpTemplate,
          offer: self.currentOffer,
          kind: kind,
          line_count: items.length
        });
        showStatus(self.statusEl, 'success', kind === 'skip' ? 'Added to cart' : 'Bundle added to cart');
        notifyCart({ source: 'product-form-component', resource: result, sections: result && result.sections, itemCount: result && result.item_count });
        flashAdded(btn, 1500);
        if (kind === 'skip' && !revealCart()) {
          window.location.href = '/cart';
        }
      }).catch(function (err) {
        showStatus(self.statusEl, 'error', (err && err.message) || 'Could not add bundle. Please try again.');
        fireEvent('add_to_cart_error', { bundle_type: 'multi_offer', offer: self.currentOffer, error: err && err.message });
      }).finally(function () {
        self._addInFlight = false;
        if (btn) btn.disabled = originalDisabled;
        if (kind === 'skip') {
          if (self.buyNowButton) self.buyNowButton.textContent = originalBuyNowText;
        } else if (self.atcTextEl) {
          self.atcTextEl.innerHTML = originalAtcHTML;
          self.atcInnerText = self.atcTextEl.querySelector('span span');
          self.applyExternalLabels();
        }
      });
    }
  }

  if (!customElements.get('bundle-cross-sell')) customElements.define('bundle-cross-sell', BundleCrossSell);
  if (!customElements.get('bundle-volume-tier')) customElements.define('bundle-volume-tier', BundleVolumeTier);
  if (!customElements.get('bundle-multi-offer')) customElements.define('bundle-multi-offer', BundleMultiOffer);
})();
